import { createAction } from "redux-starter-kit";

import { RESET_SIGNUP_STEPS } from "../types";

const resetSteps = () => createAction(RESET_SIGNUP_STEPS)();

export default resetSteps;
